import React, { useEffect, useState, useRef } from 'react';

import data from './data';
import Heading from '../../../components/Heading';
import RadioButtons from '../../../components/RadioButtons.tsx';
import { Subtitle, Description } from '../styled';
import useAnimation from '../History/useAnimation';

const Content = ({ index, setIndex }: {
  index: number,
  setIndex: (n: number) => void
}) => {
  const question = useRef<HTMLHeadingElement>(null);
  const answer = useRef<HTMLHeadingElement>(null);

  const [localIndex, setLocalIndex] = useState(index);

  const [fadeout, fadein] = useAnimation([question, answer]);

  useEffect(() => {
    fadeout.current?.play(0).eventCallback("onComplete", () => {
      setLocalIndex(index);
      fadein.current?.play(0);
    });
  }, [index]);

  const handleRadioClick = (i: number) => {
    if (
      fadeout.current && !fadeout.current.isActive() &&
      fadein.current && !fadein.current.isActive()
    ) {
      setIndex(i);
    }
  }

  return (
    <>
      <Heading number="02" label="FAQs" align="left" />

      <Subtitle ref={question}>{data[localIndex].question}</Subtitle>
      <Description ref={answer}>{data[localIndex].answer}</Description>

      <RadioButtons
        amount={data.length}
        currentActive={index}
        onRadioClick={handleRadioClick}
      />
    </>
  );
}

export default Content;